define(function (require, exports, module) {
    'use strict';

    var microtask = Promise.resolve();

    /**
     * @returns {Promise}
     */
    function requestMicrotask() {
        return microtask;
    }

    module.exports = requestMicrotask;
});
